export default {
    title: 'Profile Settings',
    subtitle: 'Manage your account information and preferences.',
    personalInfo: 'Personal Information',
    accountSettings: 'Account Settings',
    displayName: 'Display Name',
    email: 'Email',
    nextcloudId: 'Nextcloud ID',
    role: 'Role',
    status: 'Status',
    userId: 'User ID',
    active: 'Active',
    inactive: 'Inactive',
    permissions: 'Permissions',
    appSettings: 'Application Settings',
    notifications: 'Push Notifications',
    installApp: 'Install App',
    installAppDescription: 'To install the app, follow the provided instructions.',
};
